import Vue from 'vue';
import VueI18n from 'vue-i18n';
import FlagIcon from 'vue-flag-icon';

Vue.use(FlagIcon);
Vue.use(VueI18n);

const en = require('../language/en.json');
const fr = require('../language/fr.json');

let messages = { 'en': en, 'fr': fr };

export default new VueI18n({
    locale: 'fr', // set locale  
    messages, // set locale messages
});